import React from 'react'
import { useTranslation } from 'react-i18next'

import { Grid } from '@ui/Layouts/Grid/Grid'
import { Body1, Body2 } from '@ui/Typography'

import { PlatformDownloadButton } from './PlatformIcon'
import { TickmillTraderVideoData } from './platformsLearnMoreData'

import styles from './PlatformsLearnMore.module.scss'

interface VideoCardsProps {
  data: TickmillTraderVideoData[]
}

export const VideoCards: React.FC<VideoCardsProps> = (props) => {
  const { data } = props

  return (
    <Grid className={styles.imageContainer}>
      {data.map((item) => (
        <VideoCard item={item} key={item.title} />
      ))}
    </Grid>
  )
}

interface VideoCardProps {
  item: TickmillTraderVideoData
}

const VideoCard: React.FC<VideoCardProps> = (props) => {
  const { item } = props
  const { t } = useTranslation()

  return (
    <div className={styles.imageCard}>
      <PlatformDownloadButton to={item.link}>
        <img src={item.image} alt={item.title} />
      </PlatformDownloadButton>
      <div className={styles.imageText}>
        <Body1 isParagraph medium>
          {t(item.title)}
        </Body1>
        <Body2 isParagraph>{t(item.text)}</Body2>
      </div>
    </div>
  )
}
